export const routes = [
  {
    path: '/ved/region-aggregated',
    name: 'RegionAggregated',
    component: () => import('../view/RegionAggregated.vue'),
  },
  {
    path: '/ved/product-aggregated',
    name: 'ProductAggregated',
    component: () => import('../view/ProductAggregated.vue'),
  },
  {
    path: '/ved/analytics-notes-monthly',
    name: 'AnalyticsNotesMonthly',
    component: () => import('../view/AnalyticsNotesMonthly.vue'),
  },
  {
    path: '/ved/analytics-notes-yearly',
    name: 'AnalyticsNotesYearly',
    component: () => import('../view/AnalyticsNotesYearly.vue'),
  },
  {
    path: '/ved/foreign-trade-by-regions',
    name: 'ForeignTradeByRegions',
    component: () => import('../view/ForeignTradeByRegions.vue'),
  },
  {
    path: '/ved/foreign-trade-by-products',
    name: 'ForeignTradeByProducts',
    component: () => import('../view/ForeignTradeByProducts.vue'),
  },
  {
    path: '/ved/foreign-trade-by-countries',
    name: 'ForeignTradeByCountries',
    component: () => import('../view/ForeignTradeByCountries.vue'),
  },
  {
    path: '/ved/fts-monthly',
    name: 'FTSMonthly',
    component: () => import('../view/FTSMonthly.vue'),
  },
  {
    path: '/ved/fts-weekly',
    name: 'FTSWeekly',
    component: () => import('../view/FTSWeekly.vue'),
  },
  {
    path: '/ved/gas-recalculation',
    name: 'GasRecalculation',
    component: () => import('../view/GasRecalculation.vue'),
  },
  {
    path: '/ved/weekly-data-uploading',
    name: 'WeeklyDataUploading',
    component: () => import('../view/WeeklyDataUploading.vue'),
  },
  {
    path: '/ved/nsi-data-uploading',
    name: 'NSIDataUploading',
    component: () => import('../view/NSIDataUploading.vue'),
  },
  {
    path: '/ved/dbf-uploading',
    name: 'DBFUploading',
    component: () => import('../view/DBFUploading.vue'),
  },
  {
    path: '/ved/additional-uploading',
    name: 'FirstUploading',
    component: () => import('../view/AdditionalUploading.vue'),
  },
  {
    path: '/ved/additional-gas-uploading',
    name: 'SecondUploading',
    component: () => import('../view/AdditionalGasUploading.vue'),
  },
];
